import { useEffect, useState } from "react";
import { LuCheck, LuLink, LuMessageCircle, LuShare2 } from "react-icons/lu";

import { canNativeShare, careersShareUrl, copyText, whatsappHref } from "../lib/share";

export const shareText = (job) => `${job.title} at Nando's UAE`;

export function useCopied() {
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!copied) return undefined;
    const timer = setTimeout(() => setCopied(false), 2500);
    return () => clearTimeout(timer);
  }, [copied]);
  return [copied, setCopied];
}

// Native share sheet where the phone has one; otherwise copy the link.
export async function shareJob(job, onCopied) {
  const url = careersShareUrl(job.slug);
  if (canNativeShare()) {
    try {
      await navigator.share({ title: shareText(job), url });
      return;
    } catch (error) {
      if (error?.name === "AbortError") return;
    }
  }
  if (await copyText(url)) onCopied();
}

export default function ShareActions({ job, title = "Know someone who'd fit? Share this role." }) {
  const [copied, setCopied] = useCopied();
  const url = careersShareUrl(job.slug);

  const onCopy = async () => {
    if (await copyText(url)) setCopied(true);
  };

  return (
    <div>
      {title && <p className="cr-share-title">{title}</p>}
      <div className="cr-share-row">
        <a
          className="cr-btn cr-btn--whatsapp cr-btn--sm"
          href={whatsappHref(`${shareText(job)} – apply here:`, url)}
          target="_blank"
          rel="noopener noreferrer"
        >
          <LuMessageCircle aria-hidden="true" />
          WhatsApp
        </a>
        <button type="button" className="cr-btn cr-btn--secondary cr-btn--sm" onClick={onCopy}>
          {copied ? <LuCheck aria-hidden="true" /> : <LuLink aria-hidden="true" />}
          {copied ? "Link copied" : "Copy link"}
        </button>
        {canNativeShare() && (
          <button
            type="button"
            className="cr-btn cr-btn--secondary cr-btn--sm"
            onClick={() => shareJob(job, () => setCopied(true))}
          >
            <LuShare2 aria-hidden="true" />
            More
          </button>
        )}
      </div>
      <p className="cr-visually-hidden" role="status">
        {copied ? "Link copied" : ""}
      </p>
    </div>
  );
}
